import { DeleteGroupReq, Group } from "../../type/group";

export class GroupAdapter {
  static toInputDTO(req: DeleteGroupReq): any {
    return {
      category_id: req.id,
    };
  }

  static toOutputDTO(res: any): Group[] {
    return (
      res.subject_group.map((e: any) => ({
        id: e.id,
        name: e.name,
        description: e.description,
      })) || []
    );
  }
}
